module.exports = __webpack_public_path__ + "static/media/ic_download.fec141a3.svg";